export const ACCEPTED_COOKIES_NAME: string = 'accept_cookies'
export const ACCEPTED_COOKIES_TIME: number = 180

export const COOKIE_MAX_AGE_HOUR = 3600 // 1 час
export const COOKIE_MAX_AGE_SECONDS = 28800 // 8 часов
export const COOKIE_PATH = '/'
export const COOKIE_TOKEN_KEY = 'token'
export const COOKIE_REFRESH_TOKEN_KEY = 'refresh_token'
export const COOKIE_UPDATE_REFRESH_TOKEN_KEY = 'update_refresh_token'
export const COOKIE_RULES_LINK = 'https://www.rshb.ru/pd-policy/cookie/'
export const COOKIE_RECOMMENDATION_LINK = '/documents/recommend_rules.pdf'
export const COOKIE_HIDE_TIME = 2000

export const COOKIE_DIG_LECTURE_LIKE_KEY = 'digital_lecture_like'
export const COOKIE_RESEARCH_SHOWCASE_LIKE_KEY = 'research_showcase_like'
export const COOKIE_RESEARCH_DEMAND_LIKE_KEY = 'res_demand_like'

export const COOKIE_MPS_PHONE_KEY = 'ph'
export const COOKIE_MPS_PHONE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60 // 30 дней
export const COOKIE_MPS_PHONE_OPTIONS = {
  path: COOKIE_PATH,
  maxAge: COOKIE_MPS_PHONE_MAX_AGE_SECONDS,
} as const

